<template>
  <spreadsheet :opts="user_opts"></spreadsheet>
</template>

<script>
const async = require('async')

const randomPass = function(num) {
  const str = 'QWERTYUIOPASDFGHJKLZXCVBNM123456789zxcvbnmasdfghjklqwertyuiop'
  let res = ''
  for (let i = 0; i < num; i++) {
    res += str[Math.floor(Math.random() * str.length)]
  }
  return res
}
export default {
  data() {
    return {
      registeration: {
        show: false,
        url: '',
        title: '',
      },
      user_opts: {
        tableName: 'users',
        displayName: '用户',
        columns: [
          {
            label: 'account',
          },
          {
            label: '姓名',
          },
          {
            label: '猎聘账户名',
          },
          {
            label: '邮箱',
          },
          {
            label: '微信昵称',
            display: item => {},
          },
          {
            label: '密码', // 用户名：AnnieBao1 密码：MohTNpx1
            text: '重置密码',
            type: 'link',
            handler: async item => {
              try {
                if (!confirm(`确定重置${item['姓名']}的密码吗？`)) {
                  return
                }
                const pass = randomPass(8)
                app.service('users').patch(item._id, {
                  password: pass,
                  reset: true,
                })
                this.$alert(`用户名：${item.account} 密码：${pass}`, `${item['姓名']}的密码重置结果`, {
                  confirmButtonText: '确定',
                  callback: action => {},
                })
              } catch (e) {
                this.$message.error(e)
              }
            },
          },
          {
            label: '浏览器指纹', // 用户名：AnnieBao1 密码：MohTNpx1
            text: '生成一次性浏览器指纹',
            type: 'link',
            handler: async item => {
              try {
                if (!confirm(`确定要添加${item['姓名']}的浏览器指纹吗吗？`)) {
                  return
                }
                const res = await this.$axios.get(`${window.host}/generateFpCode?account=${item.account}`)
                if (res.data && res.data.status === 'success' && res.data.code) {
                  this.$alert(
                    `链接: ${window.host}/#/collectFp?code=${res.data.code}`,
                    `${item['姓名']}的浏览器指纹添加链接`,
                    {
                      confirmButtonText: '确定',
                      callback: action => {},
                    },
                  )
                } else if (res.data && res.data.status === 'fail') {
                  this.$message(res.data.msg)
                } else {
                  throw new Error(`生成链接失败`)
                }
              } catch (e) {
                this.$message.error(e)
              }
            },
          },
          {
            label: '邀请码',
            text: '生成邀请码',
            type: 'link',
            handler: async item => {
              try {
                const { data } = await this.$axios.post(`${window.host}/invitationCode`, {
                  userId: item._id,
                })
                this.$alert(data, `${item['姓名']}的邀请码`, {
                  confirmButtonText: '确定',
                  callback: action => {},
                })
              } catch (e) {
                this.$message.error(e)
              }
            },
          },
          {
            label: '微信注册链接',
            type: 'readonly',
            display: item =>
              `https://open.weixin.qq.com/connect/qrconnect?state=${
                item._id
              }&appid=wx0a3a78885aaf0f6f&redirect_uri=${encodeURI(
                'https://www.alphaconsulting.top/wxcallback',
              )}&response_type=code&scope=snsapi_login#wechat_redirect`,
          },
          {
            label: '解除app微信绑定',
            text: '解除',
            type: 'link',
            handler: item => {
              this.$alert('解除app账号绑定', `确定要重置${item['姓名']}的微信绑定？`, {
                confirmButtonText: '确定',
                callback: async action => {
                  if (action === 'confirm') {
                    const { data } = await this.$axios.post(`${window.host}/wxunbind`, {
                      id: item._id,
                    })
                    this.$message({
                      type: 'success',
                      message: data,
                    })
                  }
                },
              })
            },
          },
        ],
        fields: {
          account: 1,
          姓名: 1,
          猎聘账户名: 1,
          邮箱: 1,
          password: 1,
          wechat: 1,
        },
        defaultItem: {
          permissions: {
            所有人: '读写',
          },
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        creatable: true,
        trackable: true,
        // find: =>
        //   users.find()
        //   .then (res) =>
        //     Promise.resolve res.data
        create: item => app.service('users').create(item),
        update: (data, label, value) =>
          app
            .service('users')
            .patch(data._id, {
              [`${label}`]: value,
            })
            .then(() => {
              if (data.account === app.user.account) {
                return (app.user[`${label}`] = value)
              }
            }),
        remove: items => {
          let queue
          queue = []
          items.map(item =>
            queue.push(callback =>
              app
                .service('users')
                .remove(item._id)
                .then(res => callback()),
            ),
          )
          return async.series(queue, () => {})
        },
      },
    }
  },
  created() {
    return this.checkRole()
  },
  methods: {
    checkRole() {
      const flag = app.user && app.user.角色 && app.user.角色.includes('管理员')
      if (!flag) router.push('/')
    },
    handleTeam(items, rowObj) {
      return items.map(item => {
        let member, member_obj, ref
        member = item['成员']
        if (member) {
          member_obj = member.split(';')
          if (((ref = rowObj.account), [].indexOf.call(member_obj, ref) >= 0)) {
            return
          }
          member_obj.push(rowObj.account)
          member = member_obj.join(';')
        } else {
          member = rowObj.account
        }
        return app.api.update({
          tableName: 'groups',
          _id: item._id,
          data: {
            成员: member,
          },
        })
      })
    },
  },
}
</script>
